var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("card-heading", { attrs: { title: _vm.title } }),
      _c("p", { staticClass: "mt-1 mb-3 text-sm" }, [
        _vm._v(_vm._s(_vm.content)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }